import React from 'react';
import { MessageSquare, Send, User, Loader2 } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { Separator } from '../ui/separator';

const CommentsSection = ({ comments, newComment, onCommentChange, onAddComment, submitting }) => {
  return (
    <Card className="border-slate-100">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <MessageSquare className="h-5 w-5" />
          Comments ({comments.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        {comments.length > 0 ? (
          <div className="space-y-4 mb-4">
            {comments.map((comment) => (
              <div key={comment.comment_id} className="flex gap-3">
                <div className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                  <User className="h-4 w-4 text-emerald-600" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-medium text-slate-900 text-sm">{comment.user_name}</span>
                    <span className="text-xs text-slate-400">
                      {format(parseISO(comment.created_at), 'MMM d, h:mm a')}
                    </span>
                  </div>
                  <p className="text-sm text-slate-600">{comment.content}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-slate-500 mb-4">No comments yet</p>
        )}
        
        <Separator className="my-4" />
        
        <div className="flex gap-2">
          <Textarea
            placeholder="Add a comment..."
            value={newComment}
            onChange={(e) => onCommentChange(e.target.value)}
            className="min-h-[80px]"
            data-testid="comment-input"
          />
        </div>
        <Button
          onClick={onAddComment}
          disabled={submitting || !newComment.trim()}
          className="mt-2 bg-emerald-500 hover:bg-emerald-600 text-white"
          data-testid="add-comment-btn"
        >
          {submitting ? (
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
          ) : (
            <Send className="h-4 w-4 mr-2" />
          )}
          Add Comment
        </Button>
      </CardContent>
    </Card>
  );
};

export default CommentsSection;
